
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("g0CZR", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $0f4da21473767b34$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Slovak
var $0f4da21473767b34$export$2e2bcd8739ae039 = {
    'fabric.editor.chromeCollapsedPlaceholder': "Nap\xed\u0161te nie\u010Do\u2026",
    'fabric.editor.editorAssistiveLabel': "Hlavn\xe1 oblas\u0165 obsahu, sem za\u010Dnite zad\xe1va\u0165 text.",
    'fabric.editor.headingLink.toolbarHelpTitle': "Otvori\u0165 dial\xf3gov\xe9 okno pomoci"
};

});


//# sourceMappingURL=sk.8d2bcd32.js.map
